import {BackButton} from "../atom/BackButton";

export function Berater() {
  return (
    <>
      <main>
        <h2>Berater</h2>
        <p>
          TBD
        </p>
      </main>
      <nav>
        <BackButton />
      </nav>
    </>
  );
}